{
  "type": "object",
  "name": "Query",
  "class": "g gtr-5 gtc-1 gtr-s-4 gtc-s-2 gtr-l-2 gtc-l-3 gap",
  "definitions": [
    {
      "type": "date",
      "name": "vonbelegdatum",
      "title": "Von Belegdatum",
      "class": "gr-1 gc-1"
    },
    {
      "type": "date",
      "name": "bisbelegdatum",
      "title": "Bis Belegdatum",
      "class": "gr-2 gc-1 gr-s-1 gc-s-2"
    },
    {
      "type": "fieldOk",
      "name": "ktostammUrsache",
      "title": "Lieferant",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{nummer}} - {{kurzbez}}",
      "fieldOk": "ktostamm.lieferant",
      "parameters": {
        "aktivfirma": 0,
        "aktiv": 0,
        "geloescht": 0,
        "sperre": 0
      },
      "class": "gr-3 gc-1 gr-s-2 gc-s-1-2 gr-l-1 gc-l-3",
      "views": [{
        "type": "table",
        "title": "Daten",
        "class": "soft-table striped",
        "definition": {
          "type": "object",
          "name": "",
          "class": "py-4",
          "definitions": [
            {
              "type": "string",
              "class": "",
              "name": "nummer",
              "title": "Nummer"
            },
            {
              "type": "string",
              "class": "",
              "name": "kurzbez",
              "title": "Bezeichnung"
            },
            {
              "type": "string",
              "class": "",
              "name": "name1",
              "title": "Name"
            },
            {
              "type": "string",
              "class": "",
              "name": "name2",
              "title": ""
            },
            {
              "type": "string",
              "class": "",
              "name": "postleitzahl",
              "title": "PLZ"
            },
            {
              "type": "string",
              "class": "",
              "name": "ort",
              "title": "Ort"
            },
            {
              "type": "string",
              "class": "",
              "name": "strasse",
              "title": "Straße"
            },
            {
              "type": "string",
              "class": "",
              "name": "landeskennzeichen",
              "title": "Landeskennzeichen"
            }
          ]
        }
      }]
    },
    {
      "type": "fieldOk",
      "name": "ktostammBaustelle",
      "title": "Baustelle",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{kostenstelle}} - {{kurzbez}}",
      "fieldOk": "ktostamm.kunde.subnummer",
      "class": "gr-4 gc-1 gr-s-3 gc-s-1-2 gr-l-2 gc-l-1",
      "parameters": {
        "geloescht": 0,
        "gesperrt": 0,
        "kategorie": 2,
        "freigabedatum": "Alle",
        "KUNDENABFRAGE_KENNZEICHEN_AKTIV": "ALLE",
        "kundennummer": {
          "type": "storeReference",
          "feature": "authenticationContext",
          "getter": "data",
          "property": "ktostammnummer"
        }
      },
      "views": [{
        "type": "table",
        "title": "Daten",
        "class": "soft-table striped",
        "definition": {
          "type": "object",
          "name": "",
          "class": "py-4",
          "definitions": [
            {
              "type": "string",
              "class": "",
              "name": "8",
              "title": "Kostenstelle"
            },
            {
              "type": "string",
              "class": "",
              "name": "1",
              "title": "Kurzbezeichnung"
            },
            {
              "type": "string",
              "class": "",
              "name": "13",
              "title": "Straße"
            },
            {
              "type": "string",
              "class": "",
              "name": "14",
              "title": "PLZ"
            },
            {
              "type": "string",
              "class": "",
              "name": "15",
              "title": "Ort"
            }
          ]
        }
      }]
    },
    {
      "type": "fieldOk",
      "name": "objekt",
      "title": "Objekt (Projektnummer in TR/SR)",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{objekt}} - {{bezeichnung}}",
      "fieldOk": "objekt",
      "parameters": {
        "idktostamm_abrech": {
          "type": "storeReference",
          "feature": "authenticationContext",
          "getter": "data",
          "property": "accountid"
        }
      }
    },
    {
      "type": "date",
      "name": "faelldatum",
      "title": "Fälligkeit",
      "class": "gr-5 gc-1 gr-s-4 gc-s-1 gr-l-2 gc-l-2"
    }
  ]
}
